const MouLookup = {
    paris_mou: 'Paris MOU',
    tokyo_mou: 'Tokyo MOU',
    uscg_mou: 'USCG MOU'
};

export default MouLookup;
